export const cancellationReason = {
  backToSettingsCtaText: "Back to settings",
  form: {
    title: "Cancel Membership",
    explanation: "Tell us more",
    options: [
      {
        title: "I'm pregnant!",
        value: "pregnant",
      },
      {
        title: "No longer trying",
        value: "no_longer_trying",
      },
      {
        title: "It's too expensive",
        value: "too_expensive",
      },
      {
        title: "Not satisfied with my Conceive experience",
        value: "not_satisfied",
      },
      {
        title: "I feel I've gotten all I can out of Conceive",
        value: "gotten_all",
      },
      {
        title: "Other",
        value: "other",
      },
    ],
    placeholder: "Please tell us more",
    prompt:
      "We're so sorry to see you go. Can you tell us why you are cancelling today? We're always looking to improve our member experience.",
    submitCtaText: "Cancel subscription",
  },
};
